<template>
  <main>
    <div class="reporting_section">
      <div class="container-fluid">
        <reporting-head
          v-model:table="table"
          @create="value => {createType = value; createModal = true;}"
        />

        <create-first-report
          v-if="table === 'reports' && reports && reports.length === 0"
          @create="value => {createType = 'report'; createFirst = value; createModal = true;}"
        />

        <reports-table
          v-if="table === 'reports' && reports && reports.length > 0"
          @create="value => {createType = value.type; createFrom = value.data; createModal = true;}"
        />

        <templates-table
          v-if="table === 'templates'"
          @create="value => {createType = value.type; createFrom = value.data; createModal = true;}"
        />

        <schedules-table v-if="table === 'schedules'" />
      </div>
    </div>
  </main>

  <create-report
    v-if="createModal"
    :create-first="createFirst"
    :create-from="createFrom"
    :reports="reports"
    :templates="templates"
    :type="createType"
    @close="createModal = false; createType = 'report'; createFirst = null"
  />
</template>

<script>
require("/js/tooltipster.bundle.min.js");

import {mapActions, mapState} from 'vuex';
import ReportingHead from './includes/ReportingHead.vue';
import ReportsTable from './includes/ReportsTable.vue';
import TemplatesTable from './includes/TemplatesTable.vue';
import SchedulesTable from './includes/SchedulesTable.vue';
import CreateFirstReport from './includes/CreateFirstReport.vue';
import CreateReport from './modals/CreateReport.vue';

export default {
  components: {
    ReportingHead,
    ReportsTable,
    CreateFirstReport,
    TemplatesTable,
    SchedulesTable,
    CreateReport
  },
  data() {
    return {
      table: 'reports',
      createModal: false,
      createType: 'report',
      createFirst: null,
      createFrom: null,
    }
  },
  computed: {
    ...mapState('reports', ['reports']),
    ...mapState('templates', ['templates']),
    ...mapState('user', ['user']),
    ...mapState('reportSchedules', ['schedules']),
  },
  mounted() {
    this.getUser().then(() => {
      if (this.user.permissions.report_templates_permission === 'HIDDEN') {
        this.table = 'reports';
      } else {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.table = urlParams.get('table') ?? 'reports';
      }

      this.fetchReports();
      this.fetchTemplates();
      this.fetchSchedules();
    });

  },
  methods: {
    ...mapActions({
      fetchReports: 'reports/fetchReports',
      fetchTemplates: 'templates/fetchTemplates',
      getUser: 'user/getUser',
      fetchSchedules: 'reportSchedules/fetchSchedules',
    }),
    createReport(type) {
      this.createModal = true;
      this.createType = type;
    }
  }
}
</script>

<style scoped>
main {
  font-family: 'DM Sans', sans-serif !important;
  background-color: #F8F7F5;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
